import React from 'react';
interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}
const Logo = ({
  size = 'medium',
  showText = true
}: LogoProps) => {
  // Determine size class
  const sizeClass = {
    small: 'w-8 h-8',
    medium: 'w-10 h-10',
    large: 'w-16 h-16'
  }[size];
  const textSizeClass = {
    small: 'text-sm ml-1.5',
    medium: 'text-xl ml-2',
    large: 'text-2xl ml-3'
  }[size];
  return <div className="flex items-center" data-id="element-97">
      <div className={`${sizeClass} bg-primary rounded-lg flex items-center justify-center text-white`} data-id="element-98">
        {/* Stacked document icon */}
        <svg viewBox="0 0 24 24" className="w-2/3 h-2/3" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-99">
          <path d="M5 7h14M5 12h14M5 17h10" data-id="element-100" />
        </svg>
      </div>
      {showText && <div className={`${textSizeClass} font-bold text-secondary`} data-id="element-101">
          SukukNa
        </div>}
    </div>;
};
export default Logo;